var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { SynthesizeQueryService } from "~/services/domain-service/synthesize-query.service";
var QueryCaseTurnRecord = /** @class */ (function (_super) {
    __extends(QueryCaseTurnRecord, _super);
    function QueryCaseTurnRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchModel = {
            caseNumber: "",
            turnSource: "",
            turnType: "",
            lastCollectorName: "",
            currentCollectorName: "",
            caseTurnTime: []
        };
        _this.dataSet = [];
        return _this;
    }
    QueryCaseTurnRecord.prototype.refreshData = function () {
        var _this = this;
        this.synthesizeQueryService
            .queryCaseTurnRecord(this.searchModel, this.pageService)
            .subscribe(function (data) { return (_this.dataSet = data); });
    };
    QueryCaseTurnRecord.prototype.mounted = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(PageService)
    ], QueryCaseTurnRecord.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], QueryCaseTurnRecord.prototype, "sortService", void 0);
    __decorate([
        Dependencies(SynthesizeQueryService)
    ], QueryCaseTurnRecord.prototype, "synthesizeQueryService", void 0);
    QueryCaseTurnRecord = __decorate([
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange
            }
        })
    ], QueryCaseTurnRecord);
    return QueryCaseTurnRecord;
}(Vue));
export default QueryCaseTurnRecord;
